import { apiHostname } from 'shared/constants';

export const injectManifest = (): void => {
  const manifestTag = document.createElement('link');
  manifestTag.rel = 'manifest';
  manifestTag.href = `${apiHostname}/api/config/manifest`;
  document.querySelector('head')?.appendChild(manifestTag);
};
